$(document).ready(function(){
    $('a[href^="#"]').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
            && location.hostname == this.hostname) {
            var $target = $(this.hash);
            $target = $target.length && $target
                || $('[name=' + this.hash.slice(1) +']');
            if ($target.length) {
                var targetOffset = $target.offset().top;
                $('html,body')
                    .animate({scrollTop: targetOffset}, 1000);
                return false;
            }
        }
    });

    $('.info-hs').on('click', function(){
        $('.nutrition').fadeIn();
    });

    $('.close-modal').on('click', function(){
        $('.nutrition').fadeOut();
    });

    //Checkout 
    function clearAllQuantities() {
        return $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        dataType: "json"
        });
    }
    function getCartApi() {
        return $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json'
        });
    }
    function addToCartApi(quantity, id) {
        return $.ajax({ 
            type: 'POST', 
            url: '/cart/add.js', 
            dataType: 'json',
            data: {  
                quantity: quantity, 
                id: id 
            }
        });
    }
    // getCartApi()
    //     .success(function(data) {
    //     if( data.item_count > 0 ) {
    //         clearAllQuantities()
    //         console.log('cart updated');
    //     }
    // });

    $('.btn-cart').on('click', function(event) {
        event.preventDefault();
        variantId = $(this).attr('data');
        // console.log(variantId);
        addToCartApi(1, variantId)
        .success(function(data) {
            $('#loading-wrap').addClass('success');
            window.location.href = "/cart";
        })
        .fail(function(data) {
            window.location.href = "/404";
        });
    });
});